import styled from 'styled-components';

import { transformEaseFunction } from '#/components/styles';
import { remify } from '#/service/utils';

export const Container = styled.div`
  display: grid;
  gap: 1.5rem;
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  transition:
    opacity 0.5s ${transformEaseFunction},
    max-height 0.5s ${transformEaseFunction};

  &.enter {
    opacity: 0;
    max-height: 0;
  }

  &.enter-active {
    opacity: 1;
    max-height: ${remify(500)};
  }

  &.enter-done {
    opacity: 1;
    max-height: ${remify(500)};
  }
`;

export const LineWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Line = styled.hr`
  flex: 1;
  opacity: 0.2;
`;

export const Text = styled.span<{ $margin?: string }>`
  font: var(--fontStyleCallout);
  margin: ${({ $margin }) => $margin ?? '0'};
`;
